/* Lo que la app añade al viaje importado, sin tocar los documentos: los exámenes entran como un
   bloque más de su día (a su hora, con su monumento), para que el cartel los anuncie solos. */
import { hhmm } from '../texto.ts';
import type { Bloque, Viaje } from './tipos.ts';

const DURACION_EXAMEN = 40;            // «Duración objetivo 20-30 minutos por examen», con margen

export function enriquecer(v: Viaje): Viaje {
  const dias = v.dias.map(d => {
    const examenes = v.examenes.filter(e => e.dia === d.n && e.ini != null);
    if (!examenes.length) return d;
    const extra: Bloque[] = examenes.map(e => ({
      id: `examen-${e.id}`,
      hora: `${hhmm(e.ini)}–${hhmm(e.ini + DURACION_EXAMEN)}`,
      ini: e.ini,
      fin: e.ini + DURACION_EXAMEN,
      franja: null,
      pri: 'A',
      que: `Examen · ${e.asignatura}`,
      plan: e.sitio ?? e.plan,
      modo: 'FIJO',
      tipo: 'visita',
      examen: e,
    }));
    return { ...d, bloques: [...d.bloques, ...extra].sort((a, b) => (a.ini ?? 0) - (b.ini ?? 0)) };
  });
  return { ...v, dias };
}
